<template>
    <eg-modalv2
        height="auto"
        :width="modalSize"
        :show="show"
        @close="$emit('close', false)"
        footerPositionItens="right"
    >
        <span slot="header">Mudar senha</span>
        <div slot="body" class="body-password">
            <p>Insira a senha atual e a senha nova</p>
            <div class="row">
                <div class="input-field">
                    <eg-input
                        :valid="valid"
                        :value="password"
                        v-model="password"
                        name="password"
                        input-type="password"
                        placeholder-text="Senha atual*"
                        :has-icon="true"
                        class="search-query"
                        background-color="#FFF"
                        icon="fas fa-lock"
                        :rules="rules.password"
                        @valid="rules.password.valid = $event"
                    />
                </div>
            </div>
            <div class="row">
                <div class="input-field">
                    <eg-input
                        :valid="valid"
                        :value="newPassword"
                        v-model="newPassword"
                        name="password"
                        input-type="password"
                        placeholder-text="Nova Senha*"
                        :has-icon="true"
                        class="search-query"
                        background-color="#FFF"
                        icon="fas fa-lock"
                        :rules="rules.newPassword"
                        @valid="rules.newPassword.valid = $event"
                    />
                </div>
            </div>
            <div class="row">
                <div class="input-field">
                    <eg-input
                        :valid="valid"
                        :value="newPasswordConfirmation"
                        v-model="newPasswordConfirmation"
                        name="password"
                        input-type="password"
                        placeholder-text="Confirmação de senha*"
                        :has-icon="true"
                        class="search-query"
                        background-color="#FFF"
                        icon="fas fa-lock"
                        :rules="rules.newPasswordConfirmation"
                        @valid="rules.newPasswordConfirmation.valid = $event"
                    />
                </div>
            </div>
        </div>
        <div class="my-proposal-footer" slot="footer">
            <div class="buttons-footer">
                <eg-button
                    :loading="loading"
                    :disabled="!formValid"
                    style="margin-inline: 10px"
                    @click="sendUpdatePasswordRequest"
                    >Atualizar Senha</eg-button
                >
            </div>
        </div>
    </eg-modalv2>
</template>

<script>
import { mapActions } from 'vuex';
import { sendUpdatePasswordRequest } from '@/services/api/auth';
export default {
    props: {
        show: Boolean,
        isMobile: [Boolean, Object]
    },
    data: () => ({
        loading: false,
        password: '',
        newPassword: '',
        newPasswordConfirmation: '',
        valid: false,
        rules: {
            password: {
                name: 'Senha',
                type: 'password',
                required: true,
                length: 8,
                valid: true
            },
            newPassword: {
                name: 'Senha',
                type: 'password',
                required: true,
                length: 8,
                valid: true
            },
            newPasswordConfirmation: {
                name: 'Senha',
                type: 'password',
                required: true,
                length: 8,
                valid: true
            }
        }
    }),
    methods: {
        ...mapActions('notification', ['showNotification']),
        async sendUpdatePasswordRequest() {
            this.loading = true;
            this.valid = !this.valid;
            await setTimeout(() => {}, 500);
            try {
                if (this.formValid) {
                    if (this.newPassword != this.newPasswordConfirmation) {
                        this.loading = false;
                        return this.showNotification({ text: 'As senhas não são iguais', type: 'error' });
                    } else {
                        const data = this.makePost();
                        const { detail } = await sendUpdatePasswordRequest(data);
                        this.showNotification({ text: detail, type: 'success' });
                        this.$emit('close', false);
                    }
                }
            } catch (e) {
                console.error(e);
                this.showNotification({ text: 'Erro interno nos nossos servidores', type: 'error' });
            } finally {
                this.loading = false;
            }
        },
        makePost() {
            return {
                new_password1: this.newPassword,
                new_password2: this.newPasswordConfirmation,
                old_password: this.password
            };
        }
    },
    computed: {
        formValid() {
            return this.rules.password.valid && this.rules.newPassword.valid && this.rules.newPasswordConfirmation.valid
                ? true
                : false;
        },
        modalSize() {
            return this.isMobile ? '90%' : '675px';
        }
    }
};
</script>

<style lang="scss" scoped>
.body-password {
    width: 50%;
    margin: 0 auto;
    margin-top: 2rem /* 32px */;
    p {
        text-align: center;
    }
    // tablet
    @media screen and (max-width: 1024px) {
        width: 80%;
        margin-top: 2rem /* 32px */;
    }
    // mobile
    @media screen and (max-width: 767px) {
        width: 100%;
    }
}
</style>
